import { render, staticRenderFns } from "./automobile.vue?vue&type=template&id=3c48c854&scoped=true"
import script from "./automobile.vue?vue&type=script&lang=js"
export * from "./automobile.vue?vue&type=script&lang=js"
import style0 from "./automobile.vue?vue&type=style&index=0&id=3c48c854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48c854",
  null
  
)

export default component.exports